import {Team} from "./types";

const participantsScale: Team[] = [
    {athlete1: "Audrey", athlete2: "Thierry"},
    {athlete1: "Felix", athlete2: "Catherine"},
    {athlete1: "Daniel", athlete2: "Victoria"},
    {athlete1: "Antoine", athlete2: "Marilou"},
    {athlete1: "Rachel", athlete2: "Shawn"},
    {athlete1: "Lea", athlete2: "Muller"},
    {athlete1: "Lucile", athlete2: "Nico"},
    {athlete1: "Bamba", athlete2: "Clara"},
    {athlete1: "La Noe", athlete2: "Micheal"},
    {athlete1: "Damien", athlete2: "Ana"},
    {athlete1: "Will", athlete2: "Ornela"},
    {athlete1: "Laura", athlete2: "Guillermo"},
    {athlete1: "Olivier", athlete2: "Lauren"},
    {athlete1: "Julien", athlete2: "Kwan"},
];


const participantsRX: Team[] = [
    {athlete1: "Tanya", athlete2: "Samuel"},
    {athlete1: "Marie-Pier", athlete2: "Francois"},
    {athlete1: "Ashley", athlete2: "Danny"},
    {athlete1: "William", athlete2: "Maude"},
    {athlete1: "Katie", athlete2: "Amir"},
    {athlete1: "Alex", athlete2: "Megan"},
    {athlete1: "Killian", athlete2: "Sarah W."},
    {athlete1: "Charo", athlete2: "Sandrine"},
    {athlete1: "David", athlete2: "Andrea"},
    {athlete1: "Kass", athlete2: "Ali"},
    {athlete1: "Josianne", athlete2: "Ben"},
];


export {participantsScale, participantsRX}